import QuestionarioSeplag from "../../../../components/QuestionarioSeplag";
import CardSeplag from "../../../../components/CardSeplag";
import React, { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { estilo } from "./style.css";
import { useHistory } from "react-router-dom";
import { salvarAvaliacaoPrograma } from "../../../../service/Rag/AvaliacaoPrograma";
import { printToast } from "../../../../config/global";

const ProgramaRagExecucao = (props) => {
  const [campos, setCampos] = useState(JSON.parse(props.questionario));
  const [dadosOrcamFinan, setDadosOrcamFinan] = useState([
    ...props.dadosItemPrograma.dadosItemRag.plan72RealizadoPrograma,
  ]);
  const [totalOrcamFinan, setTotalOrcamFinan] = useState({
    codgFonte: "Total",
    vlrInicial: 0,
    vlrAtualizado: 0,
    vlrSuplementado: 0,
    vlrAnulado: 0,
    vlrContigenciadoBloqueado: 0,
    vlrEmpenhado: 0,
    vlrLiquidado: 0,
    vlrPpd: 0,
    vlrCofd: 0,
    vlrLiquidadoInicial: 0,
    vlrLiquidadoFinal: 0,
  });
  const [porcentagemPrevistoInicial, setPorcentagemPrevistoInicial] = useState(0);
  const [porcentagemPrevistoAtualizado, setPorcentagemPrevistoAtualizado] = useState(0);

  const [isPerc60PrevistoInicial, setIsPerc60PrevistoInicial] = useState(false);
  const [isPerc80PrevistoInicial, setIsPerc80PrevistoInicial] = useState(false);
  const [isPerc90PrevistoInicial, setIsPerc90PrevistoInicial] = useState(false);
  const [isPerc100PrevistoInicial, setIsPerc100PrevistoInicial] = useState(false);
  const [isPerc110PrevistoInicial, setIsPerc110PrevistoInicial] = useState(false);
  const [isPerc120PrevistoInicial, setIsPerc120PrevistoInicial] = useState(false);
  const [isPerc140PrevistoInicial, setIsPerc140PrevistoInicial] = useState(false);

  const [isPerc60PrevistoAtualizado, setIsPerc60PrevistoAtualizado] = useState(false);
  const [isPerc80PrevistoAtualizado, setIsPerc80PrevistoAtualizado] = useState(false);
  const [isPerc90PrevistoAtualizado, setIsPerc90PrevistoAtualizado] = useState(false);
  const [isPerc100PrevistoAtualizado, setIsPerc100PrevistoAtualizado] = useState(false);
  const [isPerc110PrevistoAtualizado, setIsPerc110PrevistoAtualizado] = useState(false);
  const [isPerc120PrevistoAtualizado, setIsPerc120PrevistoAtualizado] = useState(false);
  const [isPerc140PrevistoAtualizado, setIsPerc140PrevistoAtualizado] = useState(false);

  let history = useHistory();

  useEffect(() => {
    var varOrcFinan = [...props.dadosItemPrograma.dadosItemRag.plan72RealizadoPrograma];
    setDadosOrcamFinan(varOrcFinan);

    var total = {
      codgFonte: "Total",
      vlrInicial: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrInicial.toFixed(2)), 0),
      vlrAtualizado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrAtualizado.toFixed(2)), 0),
      vlrSuplementado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrSuplementado.toFixed(2)), 0),
      vlrAnulado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrAnulado.toFixed(2)), 0),
      vlrContigenciadoBloqueado: varOrcFinan.reduce(
        (acc, current) => acc + parseFloat(current.vlrContigenciadoBloqueado.toFixed(2)),
        0
      ),
      vlrEmpenhado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrEmpenhado.toFixed(2)), 0),
      vlrLiquidado: varOrcFinan.reduce((acc, current) => acc + parseFloat(current.vlrLiquidado.toFixed(2)), 0),
      vlrPpd: 0,
      vlrCofd: 0,
      vlrLiquidadoInicial: 0,
      vlrLiquidadoFinal: 0,
    };

    let vlrAtualizado = total.vlrAtualizado - total.vlrContigenciadoBloqueado;
    total.vlrPpd = total.vlrInicial != 0 ? (total.vlrEmpenhado / total.vlrInicial) * 100 : 0;
    total.vlrCofd = vlrAtualizado != 0 ? (total.vlrEmpenhado / vlrAtualizado) * 100 : 0;
    total.vlrLiquidadoInicial = total.vlrInicial != 0 ? (total.vlrLiquidado / total.vlrInicial) * 100 : 0;
    total.vlrLiquidadoFinal = total.vlrAtualizado != 0 ? (total.vlrLiquidado / total.vlrAtualizado) * 100 : 0;

    setTotalOrcamFinan(total);
    setPorcentagemPrevistoInicial(total.vlrPpd);
    setPorcentagemPrevistoAtualizado(total.vlrCofd);

    reguaPPD(total.vlrPpd);
    reguaCOFD(total.vlrCofd);
  }, []);

  function reguaPPD(percPPD) {
    if (percPPD <= 60) {
      setIsPerc60PrevistoInicial(true);
      return;
    }
    if (percPPD <= 80) {
      setIsPerc80PrevistoInicial(true);
      return;
    }
    if (percPPD <= 90) {
      setIsPerc90PrevistoInicial(true);
      return;
    }
    if (percPPD <= 100) {
      setIsPerc100PrevistoInicial(true);
      return;
    }
    if (percPPD <= 110) {
      setIsPerc110PrevistoInicial(true);
      return;
    }
    if (percPPD <= 120) {
      setIsPerc120PrevistoInicial(true);
      return;
    }
    if (percPPD > 120) {
      setIsPerc140PrevistoInicial(true);
      return;
    }
  }

  function reguaCOFD(percCOFD) {
    if (percCOFD <= 60) {
      setIsPerc60PrevistoAtualizado(true);
      return;
    }
    if (percCOFD <= 80) {
      setIsPerc80PrevistoAtualizado(true);
      return;
    }
    if (percCOFD <= 90) {
      setIsPerc90PrevistoAtualizado(true);
      return;
    }
    if (percCOFD <= 100) {
      setIsPerc100PrevistoAtualizado(true);
      return;
    }
    if (percCOFD <= 110) {
      setIsPerc110PrevistoAtualizado(true);
      return;
    }
    if (percCOFD <= 120) {
      setIsPerc120PrevistoAtualizado(true);
      return;
    }
    if (percCOFD > 120) {
      setIsPerc140PrevistoAtualizado(true);
      return;
    }
  }

  function formatarValor(value) {
    let val = (value / 1).toFixed(3).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  let headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Fonte" rowSpan={2} />
        <Column header="Dotação" colSpan={2} headerStyle={{ textAlign: "center" }} />
        <Column header="Créditos Adicionais" colSpan={2} />
        <Column header="Contingenciado / Bloqueado (C)" rowSpan={2} />
        <Column header="Empenhado (D)" rowSpan={2} />
        <Column header="Liquidado (E)" rowSpan={2} />
        <Column header="Empenhado (%)" colSpan={2} />
        <Column header="Liquidado (%)" colSpan={2} />
      </Row>
      <Row>
        <Column header="Inicial(A)" />
        <Column header="Atualizada(B)" />
        <Column header="Suplementar" />
        <Column header="Redução / Anulação" />

        <Column header="PPD(%) (D/A)" />
        <Column header="COFD (%) (D/(B-C))" />
        <Column header="Inicial (%) (E/A)" />
        <Column header="Atualizada (%) (E/B)" />
      </Row>
    </ColumnGroup>
  );

  let footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer={totalOrcamFinan.codgFonte} />
        <Column footer={formatarValor(totalOrcamFinan.vlrInicial)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrAtualizado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrSuplementado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrAnulado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrContigenciadoBloqueado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrEmpenhado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidado)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrPpd)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrCofd)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidadoInicial)} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidadoFinal)} />
      </Row>
    </ColumnGroup>
  );

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const salvar = () => {
    let v_campos = campos.map((questao) => {
      questao.valrRespostaItemQuest = questao.data;
      return { ...questao };
    });

    let codigoItem = campos[0].codigoItemRag;

    salvarAvaliacaoPrograma(codigoItem, v_campos).then((res) => {
      props.setCamposQuestionarioExecucao(JSON.stringify(campos));
      printToast({ summary: "Ação Efetuada", detail: "Análise da execução salva com sucesso" });
    });
  };

  const salvarDadosAtualizados = (e) => {
    props.setCamposQuestionarioExecucao(JSON.stringify(e));
    setCampos(e);
  };

  return (
    <>
      <CardSeplag>
        <Accordion multiple>
          <AccordionTab header="Realização Orçamentária e Financeiro do Programa">
            <DataTable
              value={dadosOrcamFinan}
              stripedRows
              showGridlines
              headerColumnGroup={headerGroup}
              footerColumnGroup={footerGroup}
              responsiveLayout="scroll"
            >
              <Column field="codgFonte" body={(e) => e.codgFonte} header="Fonte" />
              <Column field="vlrInicial" body={(e) => formatarValor(e.vlrInicial)} header="Inicial(A)" />
              <Column field="vlrAtualizado" body={(e) => formatarValor(e.vlrAtualizado)} header="Atualizada(B)" />
              <Column field="vlrSuplementado" body={(e) => formatarValor(e.vlrSuplementado)} header="Suplementar" />
              <Column field="vlrAnulado" body={(e) => formatarValor(e.vlrAnulado)} header="Redução / Anulação" />
              <Column
                field="vlrContigenciadoBloqueado"
                body={(e) => formatarValor(e.vlrContigenciadoBloqueado)}
                header="Contingenciado / Bloqueado (C)"
              />
              <Column field="vlrEmpenhado" body={(e) => formatarValor(e.vlrEmpenhado)} header="Empenhado (D)" />
              <Column field="vlrLiquidado" body={(e) => formatarValor(e.vlrLiquidado)} header="Liquidado (E)" />
              <Column field="vlrPpd" body={(e) => formatarValor(e.vlrPpd)} header="PPD(%) (D/A)" />
              <Column field="vlrCofd" body={(e) => formatarValor(e.vlrCofd)} header="COFD (%) (D/(B-C))" />
              <Column
                field="vlrLiquidadoInicial"
                body={(e) => formatarValor(e.vlrLiquidadoInicial)}
                header="Inicial (%) (E/A)"
              />
              <Column
                field="vlrLiquidadoFinal"
                body={(e) => formatarValor(e.vlrLiquidadoFinal)}
                header="Atualizada (%) (E/B)"
              />
            </DataTable>
          </AccordionTab>
          <AccordionTab header="Análise do PPD e COFD">
            <div className="content-panel">
              <div className="div-regua">
                <div className="div-titulo-grafico">
                  <h3>PPD - Planejamento e Programação da Despesa</h3>
                </div>

                <div className="div-color">
                  <div style={{ width: "10%" }}>
                    <div className="div-red">60.000%</div>
                    <div className="div-grafico-rodape">Deficiente</div>
                    {isPerc60PrevistoInicial && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoInicial.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "7.5%" }}>
                    <div className="div-yellow">80.000%</div>
                    <div className="div-grafico-rodape">Regular</div>
                    {isPerc80PrevistoInicial && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoInicial.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "6%" }}>
                    <div className="div-green">90.000%</div>
                    <div className="div-grafico-rodape">Bom</div>
                    {isPerc90PrevistoInicial && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoInicial.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "6%" }}>
                    <div className="div-blue">100.000%</div>
                    <div className="div-grafico-rodape">Ótimo</div>
                    {isPerc100PrevistoInicial && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoInicial.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "7%" }}>
                    <div className="div-green">110.000%</div>
                    <div className="div-grafico-rodape">Bom</div>
                    {isPerc110PrevistoInicial && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoInicial.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "7.5%" }}>
                    <div className="div-yellow">120.000%</div>
                    <div className="div-grafico-rodape">Regular</div>
                    {isPerc120PrevistoInicial && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoInicial.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "10%" }}>
                    <div className="div-red">140.000%</div>
                    <div className="div-grafico-rodape">Deficiente</div>
                    {isPerc140PrevistoInicial && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoInicial.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>
                </div>

                <div className="div-titulo-grafico" style={{ marginTop: "40px" }}>
                  <h3>COFD - Capacidade Operacional Financeira da Despesa</h3>
                </div>

                <div className="div-color" style={{ marginBottom: "20px" }}>
                  <div style={{ width: "10%" }}>
                    <div className="div-red">60.000%</div>
                    <div className="div-grafico-rodape">Deficiente</div>
                    {isPerc60PrevistoAtualizado && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoAtualizado.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "7.5%" }}>
                    <div className="div-yellow">80.000%</div>
                    <div className="div-grafico-rodape">Regular</div>
                    {isPerc80PrevistoAtualizado && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoAtualizado.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "6%" }}>
                    <div className="div-green">90.000%</div>
                    <div className="div-grafico-rodape">Bom</div>
                    {isPerc90PrevistoAtualizado && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoAtualizado.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "7%" }}>
                    <div className="div-blue">100.000%</div>
                    <div className="div-grafico-rodape">Ótimo</div>
                    {isPerc100PrevistoAtualizado && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoAtualizado.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "6%" }}>
                    <div className="div-green">110.000%</div>
                    <div className="div-grafico-rodape">Bom</div>
                    {isPerc110PrevistoAtualizado && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoAtualizado.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>
                  <div style={{ width: "7.5%" }}>
                    <div className="div-yellow">120.000%</div>
                    <div className="div-grafico-rodape">Regular</div>
                    {isPerc120PrevistoAtualizado && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoAtualizado.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ width: "10%" }}>
                    <div className="div-red">140.000%</div>
                    <div className="div-grafico-rodape">Deficiente</div>
                    {isPerc140PrevistoAtualizado && (
                      <div>
                        <i className="pi pi-arrow-up"></i>
                        <label>
                          {" "}
                          {porcentagemPrevistoAtualizado.toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })}
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </AccordionTab>
          <AccordionTab header="Análise Orçamentária e Financeira">
            <QuestionarioSeplag
              campos={campos}
              setCampos={salvarDadosAtualizados}
              condicao={props.condicao}
              IsMaximoCaracteres={true}
              qtdMaxCaracteres={10000}
              isDisabled={!props.podeAvaliarPrograma}
            ></QuestionarioSeplag>
          </AccordionTab>
        </Accordion>
        <br />
        <br />
        <div className="p-fluid grid">
          <div className="field col-12 md:col-8 ">&nbsp;</div>
          <div className="field col-12 md:col-2 ">
            <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
          </div>
          <div className="field col-12 md:col-2 ">
            <Button
              label="Salvar"
              className="p-button-success"
              onClick={salvar}
              disabled={!props.podeAvaliarPrograma}
            />
          </div>
          {/*<div className="field col-12 md:col-2 ">
                        <Button label="Remover" className="p-button-danger"  onClick={remover} />
                    </div>*/}
        </div>
      </CardSeplag>
    </>
  );
};

export default ProgramaRagExecucao;
